/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface NotificationsUnauthorizedError
 */
export interface NotificationsUnauthorizedError {
    /**
     * 
     * @type {number}
     * @memberof NotificationsUnauthorizedError
     */
    status: number;
    /**
     * 
     * @type {string}
     * @memberof NotificationsUnauthorizedError
     */
    title: string;
    /**
     * 
     * @type {string}
     * @memberof NotificationsUnauthorizedError
     */
    message: string;
}

/**
 * Check if a given object implements the NotificationsUnauthorizedError interface.
 */
export function instanceOfNotificationsUnauthorizedError(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "status" in value;
    isInstance = isInstance && "title" in value;
    isInstance = isInstance && "message" in value;

    return isInstance;
}

export function NotificationsUnauthorizedErrorFromJSON(json: any): NotificationsUnauthorizedError {
    return NotificationsUnauthorizedErrorFromJSONTyped(json, false);
}

export function NotificationsUnauthorizedErrorFromJSONTyped(json: any, ignoreDiscriminator: boolean): NotificationsUnauthorizedError {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'status': json['status'],
        'title': json['title'],
        'message': json['message'],
    };
}

export function NotificationsUnauthorizedErrorToJSON(value?: NotificationsUnauthorizedError | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'status': value.status,
        'title': value.title,
        'message': value.message,
    };
}

